import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import projectsModel from '$$projectModel';
import customDayTemplatesModel from '$$customDayTemplatesModel';
import createWorker from './createWorker';

class GanttWorker {
  #worker = null;

  #filterGanttIds = [];

  #dataComposers = {
    changeTasks: data => {
      const ganttIdsMap = {};
      const preparedData = {};

      data.forEach(taskChangeData => {
        const ganttId = taskChangeData.gantt_id;

        ganttIdsMap[ganttId] = true;

        if (!preparedData[ganttId]) preparedData[ganttId] = [];

        preparedData[ganttId].push(taskChangeData);
      });

      this.#filterGanttIds = Object.keys(ganttIdsMap);

      return preparedData;
    },
    changeLinks: data => {
      const ganttIdsMap = {};
      const preparedData = {};

      data.forEach(linkChangeData => {
        const ganttId = linkChangeData.gantt_id;

        ganttIdsMap[ganttId] = true;

        if (!preparedData[ganttId]) preparedData[ganttId] = [];

        preparedData[ganttId].push(linkChangeData);
      });

      this.#filterGanttIds = Object.keys(ganttIdsMap);

      return preparedData;
    },
  };

  constructor() {
    this.#initWorker();
  }

  #initWorker() {
    let version = Date.now();

    if (GT.productVersion && GT.productVersion.buildVersion) {
      version = GT.productVersion.buildVersion;
    }

    this.#worker = createWorker(`/workers/gantt_worker.js?${version}`);
  }

  #prepareModelsData() {
    const ganttIds = (this.#filterGanttIds.length && this.#filterGanttIds) || projectsModel.serialize()
      .map(o => o.gantt_id);
    const projectsCustomDays = customDayTemplatesModel.serialize();
    const resultData = {
      projectConfigs: {},
      tasksData: {},
      commonGanttConfig: {
        start_on_monday: Number(user.settings.start_on_monday),
      },
      constants: {
        GANTT_LINK_TYPES: constants.GANTT_LINK_TYPES,
        DEFAULT_TYPE_COLORS: constants.DEFAULT_TYPE_COLORS,
      },
    };

    ganttIds.forEach(ganttId => {
      const totalData = globalStore.getters['tasksModel/getTotalEstimateDataForProject'](+ganttId);
      const projectConfig = projectsModel.getProjectConfig(+ganttId);
      const customDaysData = projectsCustomDays.find(data => +data.ganttId === +ganttId);

      const workDays = new Array(7).fill(false);

      projectConfig.durationData.showDay.forEach(dayIndex => {
        if (dayIndex === 7) {
          workDays[0] = true; // sunday should be first
        } else {
          workDays[dayIndex] = true;
        }
      });

      resultData.projectConfigs[ganttId] = {
        durationData: projectConfig.durationData,
        calendar: {
          id: +ganttId,
          worktime: {
            // hours: calendar.getConfig().hours,
            hours: projectConfig.durationData.showTime, // calendar.getConfig().hours
            days: workDays, // _.values(calendar.getConfig().dates),
          },
        },
        ganttConfig: {
          auto_scheduling: projectConfig.auto_scheduling,
          estimation_mode: projectConfig.estimation_mode,
          apply_resource_calendar: projectConfig.apply_resource_calendar,
        },

        customDays: customDaysData ? customDaysData.customDays : [],
        totalDates: {
          start_date: totalData.start_date,
          end_date: totalData.end_date,
        },
      };

      resultData.tasksData[ganttId] = globalStore.getters['tasksModel/getTasksForGantt'](+ganttId);
    });

    return resultData;
  }

  async calculate(data, composer, action) {
    this.#filterGanttIds = [];
    const updatedData = this.#dataComposers[composer](data);

    if (!updatedData) {
      return Promise.resolve(false);
    }

    const innerData = this.#prepareModelsData();
    const calculatedGanttData = await this.#worker(_.cloneDeep({
      innerData,
      updatedData,
      action: action || composer,
    }));

    return Promise.resolve(calculatedGanttData);
  }
}

export default new GanttWorker();
